// import { tailwindThemeColors } from "styles/tailwindConfig";
// import { tailwindThemeScreens } from "styles/tailwindConfig";

const tailwindThemeScreens = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

// Note: These hardcoded colors are deprecated. Use CSS variables instead:
// - primary: var(--primary)
// - secondary: var(--secondary)
// - accent: var(--accent)
// - background: var(--background)
// - foreground: var(--foreground)
// - etc.

const colors = {
  // Deprecated - use CSS variables instead
  indigo: {
    500: "var(--primary)", // Use --primary instead
  },
  gray: {
    "50": "var(--background)",
    "100": "var(--secondary)",
    "200": "var(--tertiary)",
    "300": "var(--secondary)",
    "400": "var(--muted)",
    "500": "var(--muted-foreground)",
    "600": "var(--muted-foreground)",
    "700": "var(--secondary-foreground)",
    "800": "var(--foreground)",
    "900": "var(--foreground)",
    "950": "var(--foreground)",
  },
  yellow: {
    "50": "var(--accent-foreground)",
    "100": "var(--accent-foreground)",
    "200": "var(--accent-foreground)",
    "300": "var(--accent)",
    "400": "var(--accent)",
    "500": "var(--accent)",
    "600": "var(--accent)",
    "700": "var(--accent)",
    "800": "var(--accent-foreground)",
    "900": "var(--accent-foreground)",
    "950": "var(--accent-foreground)",
  },
};

export {
  tailwindThemeScreens,
  // tailwindThemeColors,
  colors,
};
